<template>
    <div id="PlaceMarker">
        <l-marker v-show="placeOn"
            :lat-lng="position"
            :icon="icon"
            @click="showPlace"
        />

        <l-locatecontrol
                v-if="geoLoc"
                v-bind:fineGeo=fineGeo
        />


        <b-container fluid class = "footer text-center">
            <b-button one-line class="m-1 float-left" v-on:click = "showPrev()" v-if="prevPlaceName || tripName">
                <font-awesome-icon icon="angle-left" size="lg"/>
            </b-button>
            <b-button
                one-line
                v-on:click = "$bvModal.show('modalConf')"
                v-show="app || curUserName==='admin'"
            >
                <font-awesome-icon icon="download" size="lg" :style="{ color: 'white' }" />
            </b-button>
            <a v-b-popover.hover.top="$t('PLACE_DESC')">
                <b-button one-line v-on:click = "showPlace()">{{ placeName }}</b-button>
            </a>
            <a v-b-popover.hover.top="$t('TRIP_PLACES') " title="" v-show="tripName">
                <b-button one-line v-on:click = "showTripPlacesList()">
                    <font-awesome-icon icon="folder-open" size="lg" :style="{ color: 'white' }" />
                </b-button>
            </a>
            <b-button one-line class="m-1 float-right" v-on:click = "showNext()" v-if="nextPlaceName">
                <font-awesome-icon icon="angle-right" size="lg"/>
            </b-button>
        </b-container>
        <div class="modalConf">
            <b-modal id="modalConf">
                <div class="d-block text-center">
                    <h4>{{this.$t('DOWNLOAD')}}?</h4>
                </div>
                <template v-slot:modal-footer="{ }">
                    <b-button variant="success" @click="download(false)"  v-show="tripName==''">{{$t('YES')}}</b-button>
                    <b-button variant="success" @click="download(true)"  v-show="tripName!=''">{{$t('AS_TRIP_PART')}}</b-button>
                    <b-button variant="success" @click="download(false)"  v-show="tripName!=''">{{$t('AS_SEPAR')}}</b-button>
                    <b-button variant="danger" @click="$bvModal.hide('modalConf')">{{$t('NO')}}</b-button>
                   </template>
            </b-modal>
        </div>

        <b-modal id="modalWait">
            <div class="d-block text-center">
                <h4>{{this.$t('WAITING')}}...</h4>
                <span v-if="progress >= 0">{{ progress }}%</span>
            </div>
            <template v-slot:modal-footer="{ }">
                <b-button variant="danger" @click="$bvModal.hide('modalWait')">{{$t('CANCEL')}}</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { BContainer, BModal, BButton } from 'bootstrap-vue';
import L from 'leaflet';
import { latLng, icon } from "leaflet";
import { LMarker } from "vue2-leaflet";
import '@/components/Yandex.js'
import MyLocateControl from '@/components/MyLocateControl'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: "PlaceMarker",
  components: {
    LMarker, 'l-locatecontrol': MyLocateControl,
    BContainer, BModal, BButton
  },
  props: {
    map: Object
  },
  data: function() {
    return {
      zoom: 17,
      minZoom: 1,
      maxZoom: 18,
      center: null,
      position: latLng(0, 0),
      showControl: true,
      placeName: '',
      userName: '',
      tripName: '',
      prevPlaceName: '',
      nextPlaceName: '',
      prevUserName: '',
      nextUserName: '',
      tripAuthorName: '',
      place: {},
      placeOn: false,
      app: false,
      geoLoc: false,
      fineGeo: false,
      curUserName: '',
      wasSaved: false,
      progress: 0,
      icon: icon({
        iconUrl: '/data/markers/marker-color.png',
        iconSize: [25, 41],
        iconAnchor: [12, 37]
      })
    };
  },
  mounted() {
    this.app = this.$store.state.app;
    /* eslint-disable */
    if (!this.app) {
        this.geoLoc = true;
        this.fineGeo = true;
    }
    else if (typeof AndroidInterface!='undefined') {
        this.fineGeo = AndroidInterface.fineGeoPermitted();
        this.geoLoc = this.fineGeo || AndroidInterface.coarseGeoPermitted();
        //alert(this.geoLoc+" "+this.fineGeo);
     }
    /* eslint-enable */
    this.curUserName = this.$store.state.curUserName;
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    this.placeName = this.$rmEncHyp(this.$route.params.itemName);
    this.getPlaceMarker();
  },
  methods: {
    async getPlaceMarker() {
        try {
            const response = await this.$http.get('/getPlaceMarker', {
                params: {
                    userName: this.userName,
                    placeName: this.placeName
                }
            });
            let placeMarker = response.data;
            this.showPlaceMarker(placeMarker);
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('PlaceMarker: getPlaceMarker() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    async showPlaceMarker(mP) {
        this.zoom = mP.markZoom;
        this.tripName = mP.tripName;
        this.prevPlaceName = mP.prevPlaceName;
        this.nextPlaceName = mP.nextPlaceName;
        this.prevUserName = mP.prevUserName;
        this.nextUserName = mP.nextUserName;
        this.tripAuthorName = mP.tripAuthorName;
        this.position = latLng(mP.markLat,mP.markLng);
        this.$store.commit('setCurPos', {lat: mP.markLat, lng: mP.markLng, zoom: this.zoom } )
        // cork for return from outer url page
        try {
            this.map.setView(this.position, this.zoom);
        }
        catch(error) { this.foo="bar"; }
    },
    showPlace() {
        this.$router.push({ path: '/Place/'+this.$addEncHyp(this.placeName)+'/'+this.$addEncHyp(this.userName) })
    },
    showTripPlacesList() {
        this.$router.push({ path: '/TripPlacesList'+'/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName) })
    },
    showPrev() {
        if(this.prevPlaceName)
            this.$router.push({ path: '/Map/PlaceMarker/'+this.$addEncHyp(this.prevPlaceName)+'/'+this.$addEncHyp(this.prevUserName) })
        else {
            //alert(this.tripAuthorName);
            this.$router.push({
                 path: '/Map/TripMarkers/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.tripAuthorName)
            })
        }
    },
    showNext() {
        this.$router.push({ path: '/Map/PlaceMarker/'+this.$addEncHyp(this.nextPlaceName)+'/'+this.$addEncHyp(this.nextUserName) })
    },
    download(inTrip) {
        this.$bvModal.hide('modalConf');
        this.$bvModal.show('modalWait');
        if(this.curUserName==='admin')
            this.$savePlaceTilesToServer(Number(this.position.lat), Number(this.position.lng), this.zoom);
        else this.savePlaceToApp(inTrip);
    },

    async savePlaceToApp(inTrip) {
        let svTripName = inTrip ? this.tripName : "";
        let tileKeys = [];
        let aroundKeys = [];
        let deferreds = [];
        let deferred;
        let lat = Number(this.position.lat)
        let lng = Number(this.position.lng)
        let zoom = this.zoom;
        this.$pushKeysAroundPlace(lat, lng, zoom, aroundKeys);
        //alert(aroundKeys.length);
        this.$itNum = aroundKeys.length;
        if(!this.wasSaved) this.$itNum++;
        this.$itMax = this.$itNum;
        for(let i=0; i<aroundKeys.length; i++) {
            try {
                deferred = await this.$http.get('/getTile', {
                    params: {
                        "key": aroundKeys[i],
                    }
                });
                if(!deferred.data.data) tileKeys.push(aroundKeys[i]);
                else {
                    //alert("to json");
                    let json = {};
                    json['key'] = deferred.data.key;
                    json['type'] = "places";
                    json['src'] = "tsw";
                    json['itemName'] = this.placeName;
                    json['userName'] = this.userName;
                    json['data'] = deferred.data.data;
                    let data = JSON.stringify(json);
                    //console.log(data);
                    /* eslint-disable */
                    if(typeof AndroidInterface!='undefined') AndroidInterface.loadTile(data);
                    /* eslint-enable */
                    this.$itNum--;
                    this.$updateJC();
                }
            }
            catch(error) {
                if(typeof error.response === 'undefined') this.$serveErr('PlaceMarker: savePlaceToApp() /geTile'+error.message);
                else this.$showErr(error.response.data, error.response.status);
            }
            deferreds.push(deferred);
        }

        if(tileKeys.length>0) {
            this.$saveTiles(tileKeys, "places", this.placeName, this.userName);
        }

        if(!this.wasSaved && this.curUserName!='admin')
        try {
            const response = await this.$http.get('/getDesc', {
                params: {
                    userName: this.userName,
                    itemName: this.placeName,
                    itemType: 'places'
                }
            });
            let item = response.data;
            var json = {};
            json['placeName'] = this.placeName;
            json['userName'] = this.userName;
            json['tripName'] = svTripName;
            json['placeLat'] = lat;
            json['placeLng'] = lng;
            json['placeZoom'] = zoom;
            json['desc'] = item.desc;
            json['audio'] = item.audio;
            json['isFirst'] = "false";
            let data = JSON.stringify(json);
            /* eslint-disable */
            if( (typeof AndroidInterface) != 'undefined') AndroidInterface.loadPlace(data);
            /* eslint-enable */
            this.wasSaved = true;
            this.$itNum--;
            this.$updateJC();
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('PlaceMarker: savePlaceToApp() /geDesc'+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  watch: {
    '$store.state.progress': function() {
        this.progress = this.$store.state.progress
        //console.log(this.progress);
        if(this.$itNum<=0) {
            this.$bvModal.hide('modalWait');
            this.$showMsg(this.$t('DONE'));
        }
    }
  }

};
</script>

<style >
</style>